import React from 'react';

import './index.scss';

const dir = require.context('assets/');
const RickJumpIcon = dir('./icon_rick_1.svg');
const SueIcon = dir('./icon_sue_1.svg');
const RickStandIcon = dir('./icon_rick_2.svg');

const SpImageArea = ({ img, name }) => (
  <div className={name}>
    <img className="img" src={img} alt={img} />
  </div>
);
const SpPointComment = ({ labelList, pattern }) => {
  return (
    <DispList labelList={labelList} pattern={pattern} />
  );
};

export default SpPointComment;


const DispList = ({ labelList, pattern }) => {
  switch (pattern) {
    case '01': 
      return (
        <Pattern01 labelList={labelList} />
      );
    case '02': 
      return (
        <Pattern02 labelList={labelList} />
      );
    case '03': 
      return (
        <Pattern03 labelList={labelList} />
      );
    default: return null;
  }
};

const Pattern01 = ({ labelList })=>(
  <div className="SpPointComment">
    <div className='contents'>
      <div><SpImageArea img={RickJumpIcon} name="topLeftCornerIcon" /></div>
      <div className="comment">
        {labelList.map(data => (
          <span className="label" key={data}>
            {data}
            <br />
          </span>
        ),
        )}
      </div>
      <div><SpImageArea img={SueIcon} name="bottomRightCornerIcon" /></div>
    </div>
  </div>
);

const Pattern02 = ({ labelList })=>(
  <div className="SpPointComment">
    <div className='contents'>
      <div><SpImageArea img={RickStandIcon} name="leftIcon" /></div>
      <div className="comment">
        {labelList.map(data => (
          <span className="label" key={data}>
            {data}
            <br />
          </span>
        ),
        )}
      </div>
    </div>
  </div>
);
const Pattern03 = ({ labelList })=>(
  <div className="SpPointComment">
    <div className='contents'>
      <div className="comment">
        {labelList.map(data => (
          <span className="label" key={data}>
            {data}
            <br />
          </span>
        ),
        )}
      </div>
      <div><SpImageArea img={SueIcon} name="topRightCornerIcon" /></div>
    </div>
  </div>
);